import { call, fork, takeEvery, take } from 'redux-saga/effects';
import { fetchRegister } from '../api'
import { registerActions } from './actions';
import { getNavigate } from '../../navigationService';


export function* createRegister({ payload }) {
    const { data, userId } = payload;
    yield call(fetchRegister, userId, data.newRegister);
}

//=====================================
//  WATCHERS
//-------------------------------------

export function* watchCreateRegister() {
    yield takeEvery(registerActions.CREATE_USER, createRegister);
}

export function* watchRegisterSucces() {
    while (true) {
        yield take(registerActions.FETCH_REGISTER_SUCCESS);
        getNavigate()('/confirm-register');
    }
}
//=====================================
//  ROOT
//-------------------------------------

export const registerSagas = [
    fork(watchCreateRegister),
    fork(watchRegisterSucces)
];